export const SearchResources = {
	es: {
		['rez_founded']: 'Encontramos tu reservación',
		['select_your_rez']: 'Selecciona tu reserva',
        ['unregistered_customer']: 'Cliente no registrado, por favor de pasar a mostrador',
        ['missing_documents_customer']: 'Documentos faltantes, por favor de pasar a mostrador',
        ['missing_ct']: 'Reserva sin cobertura total, por favor de pasar a mostrador',
        ['missing_address']: 'Dirección no registrada, por favor de pasar a mostrador',
        ['pickup_passed']: 'Fecha de recogida fuera de tolerancia, por favor de pasar a mostrador',

        ['rez_search']: 'Busca',
        ['your_rez_with']: 'Tu Reserva Con',
        ['qr_code']: 'Código QR',
        ['number']: 'Número de Reserva',
        ['search_by_name']: 'Buscar por nombre',
        ['scan_your_code']: 'Escanea tu código',

        ['enter_reservation_details']: "Ingresa tus datos <br /> de reservación",
        ['first_name']: 'Nombre',
        ['last_name']: 'Apellido',
        ['email']: 'Correo electrónico',
        ['search_by_reservation_number']: 'Buscar por número de reserva',
        ['search_by_qr']: 'Buscar por código QR',

        ['enter_reservation_number']: 'Ingresa tu número <br /> de reservación',
        ['reservation_number']: 'Número de Reserva',
        ['search_by_name_text']: 'Buscar por nombre',


        ['search']: 'Buscar',
	},
	en: {
		['rez_founded']: 'We found your reservation',
		['select_your_rez']: 'Select your reservation',
        ['unregistered_customer']: 'Unregistered customer, please proceed to the counter',
        ['missing_documents_customer']: 'Missing documents, please proceed to the counter',
        ['missing_ct']: 'Reservation without full coverage, please proceed to the counter',
        ['missing_address']: 'Missing address, please proceed to the counter',
        ['pickup_passed']: 'Pickup date out of range, please proceed to the counter',

        ['rez_search']: 'Search',
        ['your_rez_with']: 'Your Reservation With',
        ['qr_code']: 'QR Code',
        ['number']: 'Reservation Number',
        ['search_by_name']: 'Search by name',
        ['scan_your_code']: 'Scan your code',

        ['enter_reservation_details']: "Enter your <br /> reservation details",
        ['first_name']: 'First Name',
        ['last_name']: 'Last Name',
        ['email']: 'Email address',
        ['search_by_reservation_number']: 'Search by reservation number',
        ['search_by_qr']: 'Search by QR code',

        ['enter_reservation_number']: 'Enter your <br /> reservation number',
        ['reservation_number']: 'Reservation Number',
        ['search_by_name_text']: 'Search by name',

        ['search']: 'Search',
	}
}
